import { OrderModal } from '@/components/OrderWizard/OrderModal'
import { UpdateHistoryDrawer } from '@/components/_SiteWide/AuditHistory/UpdateHistoryDrawer'
import { OrderDrawer } from '@/components/_SiteWide/OrderDisplay/OrderDrawer'
import { ThirdPartyDispatchModal } from './ThirdpartyDispatchModal'
import type { DetailModalsProps } from './types'

export const DetailModals = ({
  showModal,
  orderHistoryStoreId,
  closeOrderDrawer,
  tpdOrder,
  showingTPDModal,
  handleTPDDismissModal,
  currentCarrier,
  auditOrderId,
  closeAuditDrawer,
  showingModal,
  closeModal,
  selectedOrderId,
}: DetailModalsProps) => {
  return (
    <>
      <OrderDrawer
        triggerModal={showModal}
        orderPreviewStoreId={orderHistoryStoreId}
        closeOrderDrawer={closeOrderDrawer}
      />
      <ThirdPartyDispatchModal
        order={tpdOrder}
        visible={showingTPDModal}
        dismissModal={handleTPDDismissModal}
        currentCarrier={currentCarrier}
      />
      <OrderModal showingModal={showingModal} closeModal={closeModal} selectedOrder={selectedOrderId} />
      <UpdateHistoryDrawer selectedOrderId={auditOrderId} closeAuditDrawer={closeAuditDrawer} />
    </>
  )
}
